import { isBrowser } from './common.utils'

const SID_KEY = 'analytics_sid'

const initSid = (): string => {
  if (!isBrowser()) return ''

  // URL param takes priority — handles cross-domain handoff (?sid=...)
  const urlParams = new URLSearchParams(window.location.search)
  const urlSid = urlParams.get('sid')
  if (urlSid) {
    localStorage.setItem(SID_KEY, urlSid)
    return urlSid
  }

  // Reuse existing sid if already set
  const existing = localStorage.getItem(SID_KEY)
  if (existing) return existing

  // Generate and persist a new sid
  const newSid = crypto.randomUUID()
  localStorage.setItem(SID_KEY, newSid)
  return newSid
}

// Run once on module load so the URL param is captured before anything else fires
if (isBrowser()) {
  initSid()
}

export const getSid = (): string => {
  return localStorage.getItem(SID_KEY) || initSid()
}

export const buildRedirectUrl = (targetUrl: string): string => {
  try {
    const url = new URL(targetUrl)
    url.searchParams.set('sid', getSid())
    return url.toString()
  } catch {
    // Fallback for relative URLs
    const separator = targetUrl.includes('?') ? '&' : '?'
    return `${targetUrl}${separator}sid=${getSid()}`
  }
}
